function toggleBodyClassOnView(selector, bodyClass, threshold = 0.1) {
  const el = document.querySelector(selector);
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      document.body.classList.toggle(bodyClass, entry.isIntersecting);
    },
    { threshold }
  );

  observer.observe(el);
}

function lineProperties() {
  const fields = document.querySelectorAll('.product-information--line-item--textarea, .product-information--line-item--text');

  if (!fields.length) return;

  fields.forEach(field => {
    field.addEventListener('input', function() {
      const fieldset = field.closest('fieldset');
      if (!fieldset) return;

      const setProps = fieldset.querySelectorAll('.productProps [data-form]');

      setProps.forEach(setProp => {
        if (field.value.trim() !== '') {
          setProp.setAttribute('form', setProp.getAttribute('data-form'));
        } else {
          setProp.removeAttribute('form');
        }
      });
    });
  });
}

function toggleCustomisation() {
  let btn = document.querySelector('.size-customization .customisation');
  let customisation = document.querySelector('.size-customization + .product-information--line-item');

  if(!btn || !customisation) return;

  btn.addEventListener('click', function(){
    customisation.classList.toggle('show');
  });
}

function sizeChartConvert() {
  const sizeChart = document.getElementById('sizechart');
  if (!sizeChart) return;

  const toggleBtn = sizeChart.querySelector('.size-chart-toggle .toggle input');
  const TDs = sizeChart.querySelectorAll('[data-convert]');
  const unitLabel = sizeChart.querySelector('.unitLabel');
  const headerCells = sizeChart.querySelectorAll('table td:first-child'); 

  if (!toggleBtn) return;

  toggleBtn.addEventListener('change', function() {
    const isCM = this.checked;

    TDs.forEach(td => { td.innerText = isCM ? td.dataset.cm : td.dataset.inch; });

    unitLabel.innerText = isCM ? "(Body Measurement in centimeters)" : "(Body Measurement in inches)";

    headerCells.forEach(cell => {
      cell.innerText = isCM ? cell.innerText.replace(/inch(es)?/i, "cm") : cell.innerText.replace(/cm/i, "inch");
    });
  });
}


document.addEventListener('DOMContentLoaded', function(){
  toggleCustomisation();
  lineProperties();
  sizeChartConvert();
  toggleBodyClassOnView('quantity-selector', 'in-view--quantity');
});